import React, { useState, useEffect } from "react";
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { GET_TOKEN } from "../../../helpers";
import { API_URL, GET_SALES_REPORT } from "../../../constants";
import { LoadingSpinner } from "../partials/LoadingSpinner";
import { EmptyData } from "../../Global/EmptyData/EmptyData";

export const WidgetGraphSalesReport = (props) => {
  const [salesReport, setSalesReport] = useState([]);
  const [currency, setCurrency] = useState('€');
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    setDataLoaded(false);
    const result = [];
    let hasDates = props?.filterPayload?.from || props?.filterPayload?.to;

    const generateString = () => {
      let resultString = "/?";
      
      const querryString = {
        from:
            (props.filterPayload && props.filterPayload.from) &&
            props.filterPayload.from.getFullYear() +
            "-" +
            ( props.filterPayload.from.getMonth() + 1) +
            "-" +
            props.filterPayload.from.getDate(),
        to:
            (props.filterPayload && props.filterPayload.to) &&
            props.filterPayload.to.getFullYear() +
            "-" +
            ( props.filterPayload.to.getMonth() + 1) +
            "-" +
            props.filterPayload.to.getDate(),
      };

      //eslint-disable-next-line
      Object.entries(querryString).map(([fieldItem, fieldItemValue]) => {
        if (fieldItemValue !== undefined && fieldItemValue !== null) {
          return (resultString = resultString.concat(`${fieldItem}=${fieldItemValue}&`));
        }
      });

      return resultString;
    };

    fetch(
      API_URL + 
      GET_SALES_REPORT + 
      generateString() +
      `region=${props.countryFilter || 'all'}&` +
      ((props.globalDays && !hasDates) ? `days=${props.globalDays}&` : '?') + 
      (props.globalCurrency && `currency=${props.globalCurrency}&`)

    , {
        method: "get",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + GET_TOKEN(),
        }),
    })
    .then((response) => response.json())
    .then((response) => {

        if (response.sales_report) {
          response.currency_symbol && setCurrency(response.currency_symbol);
  
          // eslint-disable-next-line
          Object.entries(response.sales_report).map(([fieldItem, fieldItemValue]) => {
            let temproraryObject = {
              name: fieldItem,
              Amount: fieldItemValue,
            };
  
            result.push(temproraryObject);
          })
        } else {
          console.error('error', response)
        }

      })
    .then(() => setDataLoaded(true), setSalesReport(result))

    return () => 
      setSalesReport([]),
      setDataLoaded(false)
  }, [props.globalDays, props.globalCurrency, props.countryFilter, props.filterPayload]);

  const DataFormater = (number) => {
    if (number > 1000000000){
      return (number/1000000000).toString() + 'B ' + currency;
    } else if(number > 1000000){
      return (number/1000000).toString() + 'M ' + currency;
    } else if(number > 1000){
      return (number/1000).toString() + 'K ' + currency;
    } else{
      return number.toString() + ' ' + currency;
    }
  }

  return (
    <>
      <div className="Salesreport__sales-report widget">
        {salesReport.length > 0 && dataLoaded === true ? (
          <ResponsiveContainer>
            <LineChart
              width={600}
              height={300}
              data={salesReport}
              margin={{ top: 5, right: 20, bottom: 5, left: 0 }}
            >
              <Line
                type="monotone"
                dataKey="Amount"
                stroke="#BB76E7"
                strokeWidth={4}
              />
              <CartesianGrid stroke="#ccc" strokeDasharray="0 0"/>
              <XAxis dataKey="name" align="left" tick={{ fontSize: 13, width: 500 }}/>
              <YAxis tickFormatter={DataFormater} tick={{ fontSize: 13, width: 500 }} margin={{ top: 5, right: 0, left: 200, bottom: 5  }}/>
              <Tooltip formatter={(value) => new Intl.NumberFormat('en').format(value) + ' ' + currency} />
            </LineChart>
          </ResponsiveContainer>
        ) : dataLoaded 
            ? <EmptyData title="No sales data in selected period found" />
            : <LoadingSpinner/>
          }
      </div>
    </>
  );
};
